import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import StudentsTable from '../../components/students/StudentsTable';
const StudentsArchive = () => (<WrapperSection><GlobalBreadcrumbs /><StudentsTable isArchive /></WrapperSection>);
export default StudentsArchive;
